import GlobalFunctions from '@/global.js'

/**
 * Call to API to get donation campaigns for a store
 * @function
 * @returns {object} A promise
 */
export const getDonationCampaigns = () => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'GET',
      url: `/app/donation/`,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to create a donation campaign
 * @function
 * @param {object} donationCampaign - The donation campaign to create
 * @returns {object} A promise
 */
export const createDonationCampaign = (donationCampaign) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      url: `/app/donation/create`,
      data: donationCampaign,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to update a donation campaign
 * @function
 * @param {object} donationCampaign - The updated donation campaign
 * @returns {object} A promise
 */
export const updateDonationCampaign = (donationCampaign) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      dataType: 'json',
      url: `/app/donation/update/${donationCampaign.id}`,
      data: donationCampaign,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
* Call to API to delete a donation campaign
* @function
* @param {object} donationCampaignId - ID of the donation campaign to delete
* @returns {object} A promise
*/
export const deleteDonationCampaign = (donationCampaignId) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'DELETE',
      url: `/app/donation/delete/${donationCampaignId}`,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to get location donation campaigns for a store
 * @function
 * @param {object} locationId - ID of the location to get location donation campaigns for
 * @returns {object} A promise
 */
export const getLocationDonationCampaigns = (locationId) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'GET',
      url: `/app/location_donation/showbylocation/${locationId}`,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to create a location donation campaign
 * @function
 * @param {object} locationDonationCampaign - The location donation campaign to create
 * @returns {object} A promise
 */
export const createLocationDonationCampaign = (locationDonationCampaign) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      url: `/app/location_donation/create`,
      data: locationDonationCampaign,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to update a location donation campaign
 * @function
 * @param {object} locationDonationCampaign - The updated location donation campaign
 * @returns {object} A promise
 */
export const updateLocationDonationCampaign = (locationDonationCampaign) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      dataType: 'json',
      url: `/app/location_donation/update/${locationDonationCampaign.id}`,
      data: locationDonationCampaign,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
* Call to API to delete a location donation campaign
* @function
* @param {object} locationDonationCampaignId - ID of the location donation campaign to delete
* @returns {object} A promise
*/
export const deleteLocationDonationCampaign = (locationDonationCampaignId) => {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'DELETE',
      url: `/app/location_donation/delete/${locationDonationCampaignId}`,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

export default {
  getDonationCampaigns,
  createDonationCampaign,
  updateDonationCampaign,
  deleteDonationCampaign,
  getLocationDonationCampaigns,
  createLocationDonationCampaign,
  updateLocationDonationCampaign,
  deleteLocationDonationCampaign
}
